import React, { useState, useEffect } from 'react';
import {
  Plus, Edit2, Trash2, Search, X, RefreshCw,
  FileText, Calendar, User, DollarSign, TrendingUp, Printer, Lock
} from 'lucide-react';
import CustomerInvoiceForm from './CustomerInvoiceForm';
import apiClient from '../services/api';

const VIOLET     = '#667eea';
const VIOLET_MID = '#7a5cbf';
const VIOLET_DK  = '#764ba2';

const printInvoice = async (inv) => {
  try {
    const res = await apiClient.get(`/CustomerInvoices.php?id=${inv.InvoiceID}`);
    if (!res.data.success) { alert('Could not load invoice for printing'); return; }
    const full = res.data.data;
    const revenuetype = full.revenuetype || [];
    const subTotal   = revenuetype.reduce((s, r) => s + parseFloat(r.cpd_Amount || r.UnitPrice || 0), 0);
    const taxTotal   = revenuetype.reduce((s, r) => s + parseFloat(r.TaxAmt || 0), 0);
    const grandTotal = subTotal + taxTotal;
    const fmt = (n) => parseFloat(n || 0).toFixed(2);
    const fmtDate = (d) => d ? new Date(d).toLocaleDateString('en-IN', { day:'2-digit', month:'short', year:'numeric' }) : '—';
    const rows = revenuetype.map((row, idx) => {
      const amt = parseFloat(row.cpd_Amount || row.UnitPrice || 0);
      const tax = parseFloat(row.TaxAmt || 0);
      const total = parseFloat(row.TotalAmt || row.Amount || 0);
      return `<tr style="background:${idx%2===0?'#fff':'#f8fafc'}"><td style="padding:9px 11px;border-bottom:1px solid #e2e8f0;font-size:12px;color:#9ca3af">${idx+1}</td><td style="padding:9px 11px;border-bottom:1px solid #e2e8f0;font-family:monospace;font-weight:600;color:#2563eb;font-size:12px">${row.ConsignmentNo||'—'}</td><td style="padding:9px 11px;border-bottom:1px solid #e2e8f0;font-size:12px"><div style="font-weight:600">${row.revenuetypename||'—'}</div>${row.ConsignmentDate?`<div style="color:#9ca3af;font-size:11px">${fmtDate(row.ConsignmentDate)}</div>`:''}</td><td style="padding:9px 11px;border-bottom:1px solid #e2e8f0;text-align:right;font-family:monospace;font-size:12px">1</td><td style="padding:9px 11px;border-bottom:1px solid #e2e8f0;text-align:right;font-family:monospace;font-size:12px">${fmt(amt)}</td><td style="padding:9px 11px;border-bottom:1px solid #e2e8f0;text-align:right;font-family:monospace;font-size:12px">${fmt(tax)}</td><td style="padding:9px 11px;border-bottom:1px solid #e2e8f0;text-align:right;font-family:monospace;font-weight:700;font-size:12px">${fmt(total)}</td></tr>`;
    }).join('');
    const html = `<!DOCTYPE html><html><head><title>Invoice - ${full.InvoiceNo}</title><style>*{box-sizing:border-box;margin:0;padding:0;}body{font-family:Arial,sans-serif;padding:24px;color:#1a1a1a;font-size:13px;}table{border-collapse:collapse;width:100%;}@page{margin:15mm;}@media print{body{padding:0;}}</style></head><body><div style="display:flex;justify-content:space-between;margin-bottom:28px"><div><div style="font-size:24px;font-weight:800;color:#1e3a5f;letter-spacing:-0.5px">TAX INVOICE</div><div style="margin-top:6px;color:#6b7280">Invoice No: <strong style="color:#111">${full.InvoiceNo}</strong></div><div style="color:#6b7280">Date: <strong style="color:#111">${fmtDate(full.InvoiceDate)}</strong></div>${full.DueDate?`<div style="color:#6b7280">Due Date: <strong style="color:#111">${fmtDate(full.DueDate)}</strong></div>`:''} ${full.ReferenceNo?`<div style="color:#6b7280">Reference: <strong style="color:#111">${full.ReferenceNo}</strong></div>`:''}</div><div style="text-align:right"><div style="font-size:20px;font-weight:700;color:#1e3a5f">LTMS</div><div style="font-size:12px;color:#6b7280;margin-top:4px">Logistics &amp; Transport</div><div style="font-size:12px;color:#6b7280">Management System</div></div></div><div style="background:#f8fafc;border:1px solid #e2e8f0;border-radius:8px;padding:12px 16px;margin-bottom:22px"><div style="font-size:11px;font-weight:700;color:#6b7280;letter-spacing:0.08em;margin-bottom:5px">BILL TO</div><div style="font-size:15px;font-weight:700">${full.customername||'—'}</div>${full.customercode?`<div style="font-size:12px;color:#6b7280;font-family:monospace">${full.customercode}</div>`:''}</div><table style="margin-bottom:22px"><thead><tr style="background:#1e3a5f"><th style="padding:10px 11px;color:#fff;font-size:11px;text-align:left;letter-spacing:0.05em">#</th><th style="padding:10px 11px;color:#fff;font-size:11px;text-align:left;letter-spacing:0.05em">CONSIGNMENT NO</th><th style="padding:10px 11px;color:#fff;font-size:11px;text-align:left;letter-spacing:0.05em">DESCRIPTION</th><th style="padding:10px 11px;color:#fff;font-size:11px;text-align:right;letter-spacing:0.05em">QTY</th><th style="padding:10px 11px;color:#fff;font-size:11px;text-align:right;letter-spacing:0.05em">AMOUNT</th><th style="padding:10px 11px;color:#fff;font-size:11px;text-align:right;letter-spacing:0.05em">TAX</th><th style="padding:10px 11px;color:#fff;font-size:11px;text-align:right;letter-spacing:0.05em">TOTAL</th></tr></thead><tbody>${rows}</tbody></table><div style="display:flex;justify-content:flex-end;margin-bottom:28px"><div style="min-width:260px"><div style="display:flex;justify-content:space-between;padding:7px 0;border-bottom:1px solid #e2e8f0"><span style="color:#6b7280">Sub Total</span><span style="font-family:monospace">${fmt(subTotal)}</span></div><div style="display:flex;justify-content:space-between;padding:7px 0;border-bottom:1px solid #e2e8f0"><span style="color:#6b7280">Tax</span><span style="font-family:monospace">${fmt(taxTotal)}</span></div><div style="display:flex;justify-content:space-between;padding:10px 0 6px;border-top:2px solid #1e3a5f;margin-top:4px"><span style="font-weight:800;font-size:14px;color:#1e3a5f">TOTAL AMOUNT</span><span style="font-family:monospace;font-weight:800;font-size:14px;color:#1e3a5f">${fmt(grandTotal)}</span></div></div></div>${(full.Notes||full.TermsConditions)?`<div style="border-top:1px solid #e2e8f0;padding-top:14px;display:flex;gap:24px">${full.Notes?`<div style="flex:1"><div style="font-size:11px;font-weight:700;color:#6b7280;letter-spacing:0.08em;margin-bottom:5px">NOTES</div><div style="font-size:12px;color:#374151;line-height:1.6">${full.Notes}</div></div>`:''} ${full.TermsConditions?`<div style="flex:1"><div style="font-size:11px;font-weight:700;color:#6b7280;letter-spacing:0.08em;margin-bottom:5px">TERMS &amp; CONDITIONS</div><div style="font-size:12px;color:#374151;line-height:1.6">${full.TermsConditions}</div></div>`:''}</div>`:''}<div style="margin-top:36px;border-top:2px solid #e2e8f0;padding-top:14px;display:flex;justify-content:space-between;align-items:flex-end"><div style="font-size:11px;color:#9ca3af">Generated by LTMS · ${new Date().toLocaleString('en-IN')}</div><div style="text-align:right"><div style="font-size:11px;color:#6b7280;margin-bottom:36px">Authorised Signatory</div><div style="border-top:1px solid #374151;padding-top:4px;font-size:11px;color:#6b7280;min-width:160px">Signature</div></div></div><script>window.onload=function(){window.print();}</script></body></html>`;
    const w = window.open('', '_blank', 'width=900,height=700');
    w.document.write(html); w.document.close();
  } catch (err) { alert('Print failed: ' + err.message); }
};

/* ══════════════════════════════════════════════════════════════════════ */

const statusBadgeCls = (s) => {
  switch ((s || '').toLowerCase()) {
    case 'paid':           return 'bg-green-50 text-green-700';
    case 'sent':           return 'bg-blue-50 text-blue-700';
    case 'overdue':        return 'bg-red-50 text-red-600';
    case 'cancelled':      return 'bg-gray-100 text-gray-400';
    case 'partially paid': return 'bg-orange-50 text-orange-700';
    default:               return 'bg-gray-100 text-gray-600';
  }
};

const CustomerInvoice = () => {
  const [invoices,      setInvoices]      = useState([]);
  const [loading,       setLoading]       = useState(true);
  const [error,         setError]         = useState('');
  const [showForm,      setShowForm]      = useState(false);
  const [editInvoice,   setEditInvoice]   = useState(null);
  const [searchTerm,    setSearchTerm]    = useState('');
  const [statusFilter,  setStatusFilter]  = useState('All');
  const [printingId,    setPrintingId]    = useState(null);

  const getSession = () => {
    try { const s = localStorage.getItem('ltms_session'); if (!s) return null; const d = JSON.parse(s); return d?.session || d; }
    catch { return null; }
  };
  const session = getSession();

  useEffect(() => { loadInvoices(); }, []);

  const loadInvoices = async () => {
    setLoading(true); setError('');
    try {
      const res = await apiClient.get('/CustomerInvoices.php');
      if (res.data.success) setInvoices(res.data.data || []);
      else throw new Error(res.data.message || 'Failed to load invoices');
    } catch (err) {
      if (err.response?.status === 401) { setError('Session expired. Please login again.'); setTimeout(() => { window.location.href = '/login'; }, 2000); }
      else setError(err.response?.data?.message || err.message || 'Failed to load invoices');
    } finally { setLoading(false); }
  };

  const handleNew   = ()    => { setEditInvoice(null); setShowForm(true); };
  const handleEdit  = (inv) => { setEditInvoice(inv);  setShowForm(true); };
  const handleClose = ()    => { setShowForm(false); setEditInvoice(null); };
  const handleSaved = ()    => { setShowForm(false); setEditInvoice(null); loadInvoices(); };
  const handlePrint = async (inv) => { setPrintingId(inv.InvoiceID); await printInvoice(inv); setPrintingId(null); };

  const isInvoicePaid = (inv) =>
    inv.IsPaid === 1 || inv.IsPaid === '1' ||
    parseFloat(inv.BalanceAmount ?? inv.TotalAmount) < parseFloat(inv.TotalAmount || 0);

  const handleDelete = async (inv) => {
    if (isInvoicePaid(inv)) { alert(`Cannot delete invoice ${inv.InvoiceNo} — a payment has already been received against it.`); return; }
    if (!window.confirm(`Delete invoice ${inv.InvoiceNo}? This cannot be undone.`)) return;
    try {
      const res = await apiClient.delete('/CustomerInvoices.php', { params: { id: inv.InvoiceID } });
      if (res.data.success) loadInvoices(); else alert('Error: ' + res.data.message);
    } catch (err) { alert('Error deleting: ' + (err.response?.data?.message || err.message)); }
  };

  const handleEditClick = (inv) => {
    if (isInvoicePaid(inv)) { alert(`Cannot edit invoice ${inv.InvoiceNo} — a payment has already been received against it.`); return; }
    handleEdit(inv);
  };

  const statuses = ['All','Draft','Sent','Paid','Partially Paid','Overdue','Cancelled'];

  const filtered = invoices.filter(inv => {
    const matchSearch = (inv.InvoiceNo||'').toLowerCase().includes(searchTerm.toLowerCase()) ||
      (inv.customername||'').toLowerCase().includes(searchTerm.toLowerCase()) ||
      (inv.ReferenceNo||'').toLowerCase().includes(searchTerm.toLowerCase());
    const matchStatus = statusFilter === 'All' || inv.Status === statusFilter;
    return matchSearch && matchStatus;
  });

  const totalAmount  = filtered.reduce((s, i) => s + parseFloat(i.TotalAmount  || 0), 0);
  const totalBalance = filtered.reduce((s, i) => s + parseFloat(i.BalanceAmount || 0), 0);

  if (!session?.companyid) {
    return (
      <div className="min-h-screen bg-[#f7f8fc] flex items-center justify-center">
        <div className="text-center text-gray-500 py-20">
          <FileText size={40} className="mx-auto mb-3 opacity-30" />
          <h3 className="font-bold text-gray-700 mb-1">No Session</h3>
          <p className="text-sm">Please select a company and financial year from the dashboard.</p>
        </div>
      </div>
    );
  }

  const spinStyle = { animation:'ci-spin 0.8s linear infinite' };

  return (
    <div className="min-h-screen bg-[#f7f8fc] font-[system-ui,sans-serif] text-gray-800">
      <style>{`
        @keyframes ci-spin { to { transform:rotate(360deg); } }
        .ci-tr:hover td { background:#faf8ff; }
        .ci-tr-selectable:hover td { background:#f5f3ff !important; }
        .ci-tr-selected td { background:#ede9fe !important; }
        .ci-tr-selected:hover td { background:#e9e2ff !important; }
      `}</style>

      {/* Page Header */}
      <div className="flex items-center justify-between px-8 py-7 shadow-lg"
        style={{ background:`linear-gradient(135deg,${VIOLET} 0%,${VIOLET_DK} 100%)` }}>
        <div className="flex items-center gap-5">
          <div className="w-14 h-14 rounded-[14px] bg-white/25 flex items-center justify-center shadow-lg flex-shrink-0">
            <FileText size={26} color="#fff" />
          </div>
          <div>
            <h1 className="m-0 text-[1.75rem] font-bold" style={{ color:'#fff', textShadow:'0 2px 4px rgba(0,0,0,0.2)' }}>Customer Invoices</h1>
            <p className="m-0 mt-1 text-sm" style={{ color:'rgba(255,255,255,0.8)' }}>Revenue invoices &amp; billing management</p>
          </div>
        </div>
        <div className="flex items-center gap-2.5">
          <button onClick={loadInvoices} disabled={loading} title="Refresh"
            className="w-10 h-10 flex items-center justify-center rounded-lg border cursor-pointer transition-all duration-150 bg-white/20 text-white border-white/30 hover:bg-white/30 disabled:opacity-50 disabled:cursor-not-allowed">
            <RefreshCw size={16} style={loading ? spinStyle : {}} />
          </button>
          <button onClick={handleNew}
            className="flex items-center gap-2 px-5 py-2.5 bg-white border-0 rounded-lg text-sm font-semibold cursor-pointer transition-all duration-200 hover:bg-violet-50 hover:-translate-y-px shadow-md"
            style={{ color: VIOLET_MID }}>
            <Plus size={18} /> New Invoice
          </button>
        </div>
      </div>

      {/* Summary Cards */}
      <div className="grid grid-cols-4 gap-4 px-8 pt-6 max-[1100px]:grid-cols-2">
        {[
          { icon: FileText,   iconBg:'bg-blue-50   text-blue-600',   value: filtered.length,                                                                                    label:'Total Invoices' },
          { icon: TrendingUp, iconBg:'bg-green-50  text-green-600',  value: totalAmount.toLocaleString(undefined,{minimumFractionDigits:2,maximumFractionDigits:2}),             label:'Total Invoiced' },
          { icon: DollarSign, iconBg:'bg-orange-50 text-orange-600', value: totalBalance.toLocaleString(undefined,{minimumFractionDigits:2,maximumFractionDigits:2}),            label:'Outstanding Balance' },
          { icon: Calendar,   iconBg:'bg-red-50    text-red-500',    value: invoices.filter(i=>i.Status==='Overdue').length,                                                    label:'Overdue' },
        ].map(({ icon: Icon, iconBg, value, label }) => (
          <div key={label} className="bg-white rounded-lg p-5 flex items-center gap-4 shadow-sm border border-gray-200">
            <div className={`w-12 h-12 rounded-xl flex items-center justify-center flex-shrink-0 ${iconBg}`}><Icon size={20} /></div>
            <div>
              <div className="text-[1.4rem] font-bold text-gray-800">{value}</div>
              <div className="text-[0.8rem] text-gray-500 mt-0.5">{label}</div>
            </div>
          </div>
        ))}
      </div>

      {/* Toolbar */}
      <div className="flex items-center gap-4 px-8 py-5 flex-wrap">
        <div className="relative flex-1 min-w-[260px]">
          <Search size={16} className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-400 pointer-events-none" />
          <input type="text" placeholder="Search invoice no, customer, reference..."
            value={searchTerm} onChange={e => setSearchTerm(e.target.value)}
            className="w-full pl-10 pr-9 py-2.5 border border-gray-200 rounded-lg text-sm bg-white outline-none transition-all duration-150 focus:border-violet-400 focus:shadow-[0_0_0_3px_rgba(102,126,234,0.12)] box-border" />
          {searchTerm && (
            <button onClick={() => setSearchTerm('')} className="absolute right-2.5 top-1/2 -translate-y-1/2 bg-transparent border-0 text-gray-400 cursor-pointer hover:text-red-500 flex items-center p-0.5 rounded">
              <X size={14} />
            </button>
          )}
        </div>
        <div className="flex gap-1.5 flex-wrap">
          {statuses.map(s => (
            <button key={s} onClick={() => setStatusFilter(s)}
              className={`px-3.5 py-1.5 rounded-full border text-[13px] cursor-pointer whitespace-nowrap transition-all duration-150 ${statusFilter === s ? 'font-semibold text-white border-violet-500' : 'bg-white text-gray-500 border-gray-200 hover:border-violet-400 hover:text-violet-600'}`}
              style={statusFilter === s ? { background: VIOLET, borderColor: VIOLET } : {}}>
              {s}
            </button>
          ))}
        </div>
        <div className="text-[13px] text-gray-500 whitespace-nowrap">
          {filtered.length} {filtered.length === 1 ? 'invoice' : 'invoices'}
        </div>
      </div>

      {/* Content */}
      {loading ? (
        <div className="flex flex-col items-center gap-3 py-16 text-gray-500">
          <span className="w-9 h-9 border-4 border-violet-100 border-t-violet-500 rounded-full block" style={spinStyle} />
          <span>Loading invoices...</span>
        </div>
      ) : error ? (
        <div className="mx-8 my-5 px-4 py-3.5 bg-red-50 border border-red-200 rounded-lg text-red-600 text-sm flex items-center gap-4">
          <strong>Error:</strong> {error}
          <button className="flex items-center gap-2 px-4 py-2 bg-white border-0 rounded-lg text-sm font-semibold cursor-pointer hover:bg-violet-50"
            style={{ color: VIOLET_MID }} onClick={loadInvoices}>Retry</button>
        </div>
      ) : filtered.length === 0 ? (
        <div className="text-center py-20 text-gray-500 px-5">
          <FileText size={52} className="mx-auto mb-3 opacity-20" />
          <h3 className="font-semibold text-gray-700 mb-1.5">{searchTerm || statusFilter !== 'All' ? 'No matching invoices' : 'No invoices yet'}</h3>
          <p className="text-sm">{searchTerm || statusFilter !== 'All' ? 'Try adjusting your search or filter' : 'Create your first customer invoice to get started'}</p>
          {!searchTerm && statusFilter === 'All' && (
            <button className="mt-4 flex items-center gap-2 px-5 py-2.5 mx-auto border-0 rounded-lg text-sm font-semibold text-white cursor-pointer"
              style={{ background:`linear-gradient(135deg,${VIOLET},${VIOLET_DK})` }} onClick={handleNew}>
              <Plus size={18} /> New Invoice
            </button>
          )}
        </div>
      ) : (
        <div className="px-8 pb-8 overflow-x-auto">
          <table className="w-full border-collapse text-[13.5px] bg-white rounded-lg overflow-hidden shadow-sm border border-gray-200">
            <thead style={{ background:'linear-gradient(135deg,#f0ebff,#e8e0f8)' }}>
              <tr>
                {['Invoice No','Invoice Date','Due Date','Customer','Sub Total','Tax','Total Amount','Balance','Status','Actions'].map(h => (
                  <th key={h} className={`px-3.5 py-3 border-b-2 border-[#d6c9f5] text-[12.5px] font-semibold uppercase tracking-wide whitespace-nowrap ${['Sub Total','Tax','Total Amount','Balance'].includes(h)?'text-right':'Actions'===h?'text-center':'text-left'}`}
                    style={{ color: VIOLET_MID }}>{h}</th>
                ))}
              </tr>
            </thead>
            <tbody>
              {filtered.map(inv => {
                const total    = parseFloat(inv.TotalAmount  || 0);
                const taxAmt   = parseFloat(inv.TaxAmount    || 0);
                const subTotal = total - taxAmt;
                const isPrinting = printingId === inv.InvoiceID;
                const isPaid     = isInvoicePaid(inv);
                const isOverdue  = inv.Status !== 'Paid' && inv.DueDate && new Date(inv.DueDate) < new Date();
                return (
                  <tr key={inv.InvoiceID} className="ci-tr border-b border-[#f0f0f8]">
                    <td className="px-3.5 py-3">
                      <span className="font-semibold cursor-pointer hover:underline" style={{ color: VIOLET }}
                        onClick={() => handleEditClick(inv)} title={isPaid ? 'Locked — payment received' : 'Click to edit'}>
                        {inv.InvoiceNo}
                        {isPaid && <Lock size={11} className="inline ml-1.5 text-red-600" style={{ verticalAlign:'middle' }} />}
                      </span>
                    </td>
                    <td className="px-3.5 py-3">
                      <span className="flex items-center gap-1 text-gray-500 text-[13px]">
                        <Calendar size={12} />{inv.InvoiceDate ? new Date(inv.InvoiceDate).toLocaleDateString() : '—'}
                      </span>
                    </td>
                    <td className={`px-3.5 py-3 ${isOverdue ? 'text-red-600 font-semibold' : ''}`}>
                      {inv.DueDate ? new Date(inv.DueDate).toLocaleDateString() : '—'}
                    </td>
                    <td className="px-3.5 py-3">
                      <span className="flex items-center gap-1.5 text-gray-500">
                        <User size={12} />
                        <span>
                          <div className="text-gray-800 font-medium text-[13px]">{inv.customername || '—'}</div>
                          {inv.customercode && <div className="text-[11px] text-gray-400">{inv.customercode}</div>}
                        </span>
                      </span>
                    </td>
                    <td className="px-3.5 py-3 text-right font-mono">{subTotal.toFixed(2)}</td>
                    <td className="px-3.5 py-3 text-right font-mono">{taxAmt.toFixed(2)}</td>
                    <td className="px-3.5 py-3 text-right font-mono font-bold">{total.toFixed(2)}</td>
                    <td className="px-3.5 py-3 text-right font-mono">{parseFloat(inv.BalanceAmount||0).toFixed(2)}</td>
                    <td className="px-3.5 py-3">
                      <span className={`inline-block px-2.5 py-0.5 rounded-xl text-[12px] font-semibold whitespace-nowrap ${statusBadgeCls(inv.Status)}`}>
                        {inv.Status || 'Draft'}
                      </span>
                    </td>
                    <td className="px-3.5 py-3">
                      <div className="flex gap-1 justify-center">
                        {/* Print */}
                        <button onClick={() => handlePrint(inv)} disabled={isPrinting} title="Print Invoice"
                          className="w-8 h-8 flex items-center justify-center rounded-md border cursor-pointer transition-all duration-150 disabled:cursor-not-allowed"
                          style={isPrinting ? { color:'#9ca3af', borderColor:'#e5e7eb', background:'#f9fafb' } : { color:'#2563eb', borderColor:'#bfdbfe', background:'#eff6ff' }}>
                          {isPrinting
                            ? <span style={{ width:14,height:14,border:'2px solid #9ca3af',borderTopColor:'transparent',borderRadius:'50%',display:'inline-block',animation:'ci-spin 0.7s linear infinite' }} />
                            : <Printer size={14} />}
                        </button>
                        {/* Edit */}
                        {isPaid ? (
                          <span className="w-8 h-8 flex items-center justify-center rounded-md border text-gray-400 border-gray-200 bg-gray-50" style={{ cursor:'not-allowed' }} title="Locked — payment received">
                            <Lock size={14} />
                          </span>
                        ) : (
                          <button onClick={() => handleEditClick(inv)} title="Edit Invoice"
                            className="w-8 h-8 flex items-center justify-center rounded-md border cursor-pointer transition-all duration-150 hover:bg-violet-50 hover:border-violet-300"
                            style={{ color: VIOLET, borderColor:'transparent', background:'none' }}>
                            <Edit2 size={14} />
                          </button>
                        )}
                        {/* Delete */}
                        <button onClick={() => handleDelete(inv)} disabled={isPaid}
                          title={isPaid ? 'Locked — payment received' : 'Delete Invoice'}
                          className="w-8 h-8 flex items-center justify-center rounded-md border cursor-pointer transition-all duration-150 hover:bg-red-50 disabled:cursor-not-allowed"
                          style={isPaid ? { color:'#9ca3af', borderColor:'#e5e7eb', background:'#f9fafb' } : { color:'#e53e3e', borderColor:'transparent', background:'none' }}>
                          <Trash2 size={14} />
                        </button>
                      </div>
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
      )}

      {showForm && (
        <CustomerInvoiceForm editData={editInvoice} onClose={handleClose} onSaved={handleSaved} />
      )}
    </div>
  );
};

export default CustomerInvoice;